import { render, staticRenderFns } from "./CardRankingRoom.vue?vue&type=template&id=725e52ae"
import script from "./CardRankingRoom.vue?vue&type=script&lang=js"
export * from "./CardRankingRoom.vue?vue&type=script&lang=js"
import style0 from "./CardRankingRoom.vue?vue&type=style&index=0&id=725e52ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports